<h2 class="dialog-fail_title" mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'alert.notification' | translate}}
    <button type="button" class="close v2-btn-close dialog-fail_close-btn" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
</h2>
<div style="padding: 0 24px;">
  <mat-divider inset="true"></mat-divider>
</div>
<div class="wrap-popup">
  <div class="row">
    <div class="col-2 pr-0" style="text-align: center; padding-top: 15px;">
      <img style="max-width:100%" src="./assets/images/kyc_success.png" alt="">
    </div>
    <div class="col-10 pr-0">
      <div [innerHTML]="data.message | translate" style=" padding: 5px 7px 0; font-size: medium; overflow-wrap: break-word; font-weight: 600"></div>
      <p style="padding: 0 7px 0; font-size: medium; overflow-wrap: break-word; font-weight: 600">Chú ý: Lượt EKYC sẽ bị trừ vào lượt của người lập hợp đồng.</p>
    </div>
  </div>
  
  
  <div mat-dialog-actions class="justify-content-center">
    <button *ngIf="data.isLogin" class="ml-4 v2-btn-accept v2-font-semi" mat-raised-button >
      <mat-icon class="mr-2">library_books</mat-icon>{{'button.nav_to_detail_document' | translate}}
    </button>
    <button *ngIf="!data.isLogin" class="ml-4 v2-btn-accept v2-font-semi" mat-raised-button >
      <mat-icon class="mr-2">format_list_bulleted</mat-icon>{{'button.nav_to_list_document' | translate}}
    </button>
  </div>
</div>
